export const UtcToLocalDateString = (utcDate: Date) => {
  return new Date(utcDate).toLocaleString();
};

export const safeDiv = (a: number, b: number): number => {
  if (b === 0) return 0;
  return a / b;
};

export const safeParseInt = (str: string): number => {
  var value = parseInt(str.replace(/,/g, ""), 10);
  //let value = Number(str);
  if (isNaN(value)) {
    value = 0;
  }
  return value;
};
